module.exports = __webpack_public_path__ + "static/media/add-item.132f7994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/add-item.svg
// module id = 1681
// module chunks = 0